// where should these types live? feature folders with types could be beneficial.
export type PlanSubmission = {
  planID: number;
  reviewers: PlanReviewer[];
  status: SubmissionStatus;
  withdrawn?: Withdrawal;
  submission: Submission;
  createdAt: string;
  updatedAt: string;
};

export enum SubmissionStatus {
  Submitted = "Submitted",
  Approved = "Approved",
  Rejected = "Rejected",
  Withdrawn = "Withdrawn",
  Draft = "Draft"
}

export enum ReviewerStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected"
}

export type PlanReviewer = {
  username: string;
  displayName?: string;
  status: ReviewerStatus;
  feedback?: string;
  responseDate?: string;
};

type Withdrawal = {
  message: string;
  date: string;
  username: string;
  displayName?: string;
};

type Submission = {
  message: string;
  date: string;
  username: string;
  displayName?: string;
};
